module.exports = __webpack_public_path__ + "img/Icon-star-right.37c0e11d.svg";